// eslint-disable-next-line import/prefer-default-export
export const ALL_LOCATIONS = 'allLocations';
